import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const SuccessModal = ({
  showSuccessModal,
  setShowSuccessModal,
  successMessage
  }) => {

  const handleNavigation = () => {
    if (successMessage && successMessage.linkTo) {
      window.location = successMessage.linkTo;
      setShowSuccessModal(false);
    }
  }

  return <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} animation={false} centered>
    <Modal.Header>
      <Modal.Title>{I18n.t('js.common.modal.successTitle')}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h4>
        <div className="d-block" >
          <div className="d-flex justify-content-center align-items-center text-center mt-3">
            <p className="ml-2 text-space">
              { successMessage && successMessage.message ? successMessage.message : "" }
              {
                successMessage && successMessage.linkTo && successMessage.linkContent &&
                  <span id="link-content-success"
                    style={{color: "inherit", textDecoration: "underline", cursor: 'pointer' }}
                    onClick={handleNavigation}>
                    &nbsp;{successMessage.linkContent}
                  </span>
              }
            </p>
          </div>
          {
            successMessage && successMessage.additionalText &&
              <div className="d-flex justify-content-center align-items-center mt-4">
                <p className="ml-2 text-space">
                  { successMessage.additionalText }
                </p>
              </div>
          }
        </div>
      </h4>

    </Modal.Body>
    <Modal.Footer>
      <button
        type="button"
        className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
        onClick={() => setShowSuccessModal(false)}
      >
        {I18n.t('js.common.ok').toUpperCase()}
      </button>
    </Modal.Footer>
  </Modal>
};

export default SuccessModal;